import { render, staticRenderFns } from "./nlp-analysis-highlighting.html?vue&type=template&id=2b389095&scoped=true&"
import script from "./nlp-analysis-highlighting.js?vue&type=script&lang=js&"
export * from "./nlp-analysis-highlighting.js?vue&type=script&lang=js&"
import style0 from "./nlp-analysis-highlighting.scss?vue&type=style&index=0&id=2b389095&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b389095",
  null
  
)

export default component.exports